import { Box, Typography, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';

interface SectionProps {
  title: string;
}

export default function Section({
  title,
  children,
}: PropsWithChildren<SectionProps>) {
  const theme = useTheme();
  return (
    <Box
      width="100%"
      paddingTop={2.5}
      borderTop={1}
      borderColor={theme.palette.lightGrey.main}>
      {title && (
        <Typography variant="h3" marginBottom={2.5}>
          {title}
        </Typography>
      )}
      {children}
    </Box>
  );
}
